import { StyleSheet } from 'react-native-unistyles'

import Card from '@/components/shared/Card'
import UniText from '@/components/unistyles/UniText'

const NotFound = () => {
  return (
    <Card style={styles.root} title="Not Found">
      <UniText>The data you're looking for could not be found.</UniText>
    </Card>
  )
}

const styles = StyleSheet.create((theme) => ({
  root: {
    alignItems: 'center',
    alignSelf: 'center',
    paddingBottom: theme.tokens.spacing[6],
    paddingTop: theme.tokens.spacing[6],
    width: 500,
  },
}))

export default NotFound
